import { Container, styled } from "@mui/material";

export const FormWrapper = styled(Container)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: theme.spacing(2),
  boxSizing: "border-box"
}));
